<div class="container">
  <div class="row">
    <mat-stepper #stepper>
      <!-- Step - 1 -->
      <mat-step
        [stepControl]="firstFormGroup"
        label="Questionnaire Type"
        state="step1"
      >
        <div class="col-12">
          <div class="row justify-content-md-center">
            <mat-card class="result col-7" style="padding: 25px">
              <!-- Step Title -->
              <mat-card-subtitle>
                <div class="row justify-content-md-center">
                  <div class="col-12" style="text-align: start">
                    Choose the type of Questionnaire you would like to generate
                    from the options below
                  </div>
                </div>
              </mat-card-subtitle>

              <!-- Step Content Form -->
              <mat-card-content style="margin-top: 25px">
                <div
                  class="row justify-content-md-center step-1-question"
                  *ngFor="let question of stepOneQuestions; let i = index"
                >
                  <div class="col-12">
                    <section
                      class="example-section"
                      *ngIf="
                        question &&
                        question.description &&
                        question.description.length
                      "
                    >
                      <mat-checkbox
                        class="example-margin"
                        [(ngModel)]="question.isChecked"
                        (change)="checkValue(question, i)"
                      >
                        <span
                          [innerHtml]="question.description"
                          style="
                            color: #333;
                            font-weight: 400;
                            font-size: 14px;
                            display: inline-block;
                            white-space: pre-line;
                          "
                        ></span>
                        <span
                          *ngIf="question.type === QuestionnaireType.MANUAL"
                        >
                          {{
                            selectedReportDate?.test_date
                              | date: 'dd-MM-yyyy h:mm'
                          }}</span
                        >
                      </mat-checkbox>
                    </section>

                    <!-- Selection List for the templates -->
                    <mat-form-field
                      appearance="outline"
                      *ngIf="
                        isTemplateSpecific &&
                        question.type == QuestionnaireType.TEMPLATE_BASED
                      "
                    >
                      <mat-select
                        placeholder="Select Template"
                        [(ngModel)]="selectedTemplate"
                      >
                        <mat-option
                          *ngFor="let template of templates"
                          [value]="template"
                          >{{ template.questionnaireSchema.title }}</mat-option
                        >
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div class="col-12">
          <div class="row justify-content-md-end">
            <button
              mat-stroked-button
              class="action-button cancel"
              (click)="goToBack('dashboard')"
            >
              Back to Dashboard
            </button>
            <button
              mat-stroked-button
              class="action-button next"
              (click)="typeSelected()"
              [disabled]="disableNext()"
            >
              <ng-container *ngIf="loadingQuestion">
                <mat-spinner diameter="20"></mat-spinner>
              </ng-container>
              <ng-container *ngIf="!loadingQuestion"> Next </ng-container>
            </button>
          </div>
        </div>
      </mat-step>

      <!-- Step-2 -->

      <mat-step
        label="Prompt Writing"
        state="step3"
        *ngIf="showPromptWriting()"
      >
        <div class="col-12">
          <div class="row justify-content-md-center" style="min-height: 60vh">
            <mat-card class="result col-7">
              <!-- Step Title -->
              <mat-card-subtitle style="color: #000000">
                <div class="row justify-content-md-center">
                  <div class="col-12" style="text-align: start">
                    <span [innerHTML]="stepTwoTitle"></span>
                  </div>
                </div>
              </mat-card-subtitle>
              <mat-card-content style="margin-top: 25px">
                <div class="row justify-content-md-center" style="margin: 0px">
                  <mat-list style="width: 100%" *ngIf="isProfileSpecific">
                    <mat-list-item
                      *ngFor="let userInfo of stepTwoInfo.userInfo"
                      style="
                        background-color: #f9f9f9 !important;
                        margin-bottom: 10px;
                      "
                    >
                      <mat-icon
                        matListItemIcon
                        style="margin-right: 8px; color: #a8a8a8"
                        *ngIf="userInfo.icon"
                        >{{ userInfo.icon }}</mat-icon
                      >
                      <div
                        matListItemTitle
                        style="
                          font-size: 14px;
                          margin-right: 5px;
                          color: #333333;
                        "
                        *ngIf="userInfo.name"
                      >
                        {{ userInfo.name }}:
                      </div>
                      <div
                        matListItemLine
                        *ngIf="userInfo.key"
                        style="color: #333333"
                      >
                        {{ userInfo.key }}
                      </div>
                    </mat-list-item>
                  </mat-list>

                  <mat-list style="width: 100%" *ngIf="isResultSpecific">
                    <mat-list-item
                      *ngFor="let userInfo of stepTwoInfo.testInfo"
                      style="
                        background-color: #f9f9f9 !important;
                        margin-bottom: 10px;
                      "
                    >
                      <mat-icon
                        matListItemIcon
                        style="margin-right: 8px; color: #a8a8a8"
                        *ngIf="userInfo.icon"
                        >{{ userInfo.icon }}</mat-icon
                      >
                      <div
                        matListItemTitle
                        style="
                          font-size: 14px;
                          margin-right: 5px;
                          color: #333333;
                        "
                        *ngIf="userInfo.name"
                      >
                        {{ userInfo.name }}:
                      </div>
                      <div
                        matListItemLine
                        *ngIf="userInfo.key"
                        style="color: #333333"
                      >
                        {{ userInfo.key }}
                      </div>
                    </mat-list-item>
                  </mat-list>

                  <div class="col-12" style="padding-left: 0px">
                    <p
                      *ngIf="isResultSpecific"
                      style="text-align: left !important"
                    >
                      Blood count test results to be used from
                      {{ resultSet.observationDate | date: 'dd-MM-yyyy h:mm' }}
                    </p>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="result col-5">
              <mat-card-subtitle>
                <textarea
                  matInput
                  cols="65"
                  rows="18"
                  [(ngModel)]="stepTwoPrompt"
                >
                </textarea>
              </mat-card-subtitle>
            </mat-card>
          </div>
        </div>
        <div class="col-12">
          <div class="row justify-content-md-end">
            <button
              mat-stroked-button
              class="action-button cancel"
              (click)="goToBack('dashboard')"
            >
              Back to Dashboard
            </button>
            <button
              mat-stroked-button
              class="action-button cancel"
              matStepperPrevious
            >
              Cancel
            </button>
            <button
              mat-stroked-button
              class="action-button next"
              (click)="generate()"
            >
              Generate
            </button>
          </div>
        </div>
      </mat-step>

      <!-- Step-3 -->
      <mat-step label="Generated Questionnaires" state="step4">
        <!-- Edit Mode -->

        <div
          id="surveyCreator"
          *ngIf="
            (stepper.selectedIndex === 2 || stepper.selectedIndex === 1) &&
            model &&
            !previewMode &&
            !publishQuestion
          "
        >
          <survey-creator [model]="model"></survey-creator>
        </div>
        <!-- View Mode -->
        <div
          id="surveyView"
          *ngIf="
            (stepper.selectedIndex === 2 || stepper.selectedIndex === 1) &&
            model &&
            previewMode &&
            surveyModel &&
            !publishQuestion
          "
        >
          <survey [model]="surveyModel"></survey>
        </div>

        <div
          class="row"
          *ngIf="stepper.selectedIndex === 2 && loadingQuestion"
          style="min-height: 350px !important"
        >
          <div class="col-12 text-center" style="margin: auto">
            <img src="../../../assets/gpt/loder.gif" />
            <p
              style="
                color: var(--secondary-black-500, #a8a8a8);
                font-family: Open Sans;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              "
            >
              Generating Questionnaires...
            </p>
          </div>
        </div>

        <div
          class="row"
          *ngIf="
            (stepper.selectedIndex === 2 || stepper.selectedIndex === 1) &&
            publishQuestion
          "
        >
          <div class="col-12 text-center">
            <div class="row" style="background-color: #e1f6f5">
              <div class="col-12">
                <p
                  style="
                    margin-top: 15px;
                    color: var(--status-success, #00978d);
                    font-family: Montserrat;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                  "
                >
                  Published Successfully!
                </p>
                <p
                  style="
                    color: var(--secondary-black-600, #777);
                    margin-bottom: 10px;
                    font-family: Open Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                  "
                >
                  Your Questionnaires Published Successfully and sent to your
                  subscribers
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 text-center" style="margin-top: 20px">
            <button
              mat-stroked-button
              class="action-button"
              (click)="onBackToDashboard()"
            >
              Back to dashboard
            </button>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex align-items-center">
          <div class="col-3">
            <div class="row justify-content-md-start">
              <section
                class="example-section"
                style="margin-top: 20px"
                *ngIf="!loadingQuestion && !publishQuestion"
              >
                <mat-checkbox
                  *ngIf="!isTemplateSpecific"
                  class="example-margin"
                  [(ngModel)]="isTemplate"
                  >Save as template
                </mat-checkbox>
              </section>
            </div>
          </div>
          <div class="col-9">
            <div class="row justify-content-md-end">
              <button
                mat-stroked-button
                matStepperPrevious
                class="action-button cancel"
                *ngIf="!publishQuestion"
                (click)="goToBack()"
              >
                Cancel
              </button>
              <button
                mat-stroked-button
                class="action-button edit"
                *ngIf="!previewMode && !loadingQuestion && !publishQuestion"
                (click)="preview()"
              >
                Preview as a Subscriber
              </button>
              <button
                mat-stroked-button
                class="action-button edit"
                *ngIf="previewMode && !publishQuestion"
                (click)="editMode()"
              >
                Back to Edit Mode
              </button>
              <button
                mat-stroked-button
                class="action-button next"
                *ngIf="!loadingQuestion && !publishQuestion"
                [disabled]="isPublishing"
                (click)="publish()"
              >
                <ng-container *ngIf="isPublishing">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>

                <ng-container *ngIf="!isPublishing">
                  Publish Questionnaire
                </ng-container>
              </button>
            </div>
          </div>
        </div>
      </mat-step>

      <!-- Icons Change on Stepper -->
      <ng-template matStepperIcon="step1">
        <mat-icon>ballot</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="step2">
        <mat-icon>people_alt</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="step3">
        <mat-icon>offline_bolt</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="step4">
        <mat-icon>generating_tokens</mat-icon>
      </ng-template>
      list
    </mat-stepper>
  </div>
</div>
